<template>
  <span
    v-if="type === 'profile'"
    class="mobile-symbol-icon mobile-symbol-icon--profile"
    aria-hidden="true"
  ></span>

  <svg
    v-else-if="type === 'expertise'"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="m12 3 8 4.5-8 4.5-8-4.5L12 3Z" />
    <path d="m4 12 8 4.5 8-4.5" />
    <path d="m4 16.5 8 4.5 8-4.5" />
  </svg>

  <svg
    v-else-if="type === 'contact'"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="18" height="14" x="3" y="5" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>

  <svg
    v-else-if="type === 'vecura'"
    viewBox="70 55 1080 890"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <polygon
      points="357.1 918 358.2 613.4 1107.4 103.7 1109.1 405.2 357.1 918"
    />
    <path
      d="M347.4,105.7c-17.3,7.9-34,16.8-50,26.8l-15.3,10.1c-111.6,76.8-184.9,205.3-184.9,351s27.7,172.6,74.9,241.1l184.9-121.7V102.3l-9.7,3.4Z"
    />
  </svg>

  <svg
    v-else-if="type === 'info'"
    class="mobile-symbol-svg mobile-symbol-svg--info"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M14.8 7.2c-.6-1.2-1.7-1.9-3.1-1.9-1.8 0-3 .9-3 2.3 0 1.5 1.3 2.1 3.3 2.8 2.2.8 3.5 1.5 3.5 3.3 0 1.6-1.4 2.8-3.6 2.8-1.6 0-2.9-.7-3.6-1.9"
    />
    <path
      d="M9.1 19.1c.6 1.1 1.7 1.6 3.1 1.6 1.8 0 3-.9 3-2.3 0-1.5-1.3-2.1-3.3-2.8-2.2-.8-3.5-1.5-3.5-3.3 0-1.6 1.4-2.8 3.6-2.8 1.4 0 2.6.5 3.3 1.4"
    />
  </svg>

  <svg
    v-else-if="type === 'compass'"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="8.5" />
    <path d="m15.2 8.8-2.1 5.1-5.1 2.1 2.1-5.1 5.1-2.1Z" />
  </svg>

  <svg
    v-else-if="type === 'brain'"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M9 5.2a3 3 0 0 0-4 4.4 3.3 3.3 0 0 0 .2 5.2A3 3 0 0 0 9 19" />
    <path d="M15 5.2a3 3 0 0 1 4 4.4 3.3 3.3 0 0 1-.2 5.2A3 3 0 0 1 15 19" />
    <path d="M9 5v14" />
    <path d="M15 5v14" />
    <path d="M9 9h3" />
    <path d="M12 15h3" />
  </svg>

  <svg
    v-else-if="type === 'shield'"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12 3 20 6v6c0 4.5-3.1 7.4-8 9-4.9-1.6-8-4.5-8-9V6l8-3Z" />
    <path d="m8.8 12.2 2.1 2.1 4.5-5" />
  </svg>

  <svg
    v-else
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="16" height="12" x="4" y="7" rx="2" />
    <path d="M8 7V5.8A1.8 1.8 0 0 1 9.8 4h4.4A1.8 1.8 0 0 1 16 5.8V7" />
    <path d="M4 12h16" />
  </svg>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type MobileSymbolType =
  | "profile"
  | "expertise"
  | "contact"
  | "vecura"
  | "info"
  | "compass"
  | "brain"
  | "shield"
  | "briefcase";

export default defineComponent({
  name: "MobileSymbolIcon",
  props: {
    type: {
      type: String as PropType<MobileSymbolType>,
      required: true,
    },
  },
});
</script>

<style scoped>
.mobile-symbol-icon {
  display: block;
  flex: 0 0 auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.mobile-symbol-icon--profile {
  width: 20px;
  height: 16px;
  background-image: url("../../assets/rothdeutsch-mark.png");
}
</style>
